import React, { FC } from "react";
import { COLOR_GREY_6 } from "../colors";
import { IconType } from "./types";

export const StarBigIcon: FC<IconType> = ({ color = COLOR_GREY_6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M10.9944 1.63488C11.3744 0.788375 12.6256 0.788374 13.0056 1.63488L15.7285 7.09165C15.887 7.44474 16.2339 7.68654 16.633 7.72204L23.0048 8.60422C23.9614 8.68933 24.348 9.83081 23.6263 10.4391L18.9874 14.8022C18.6863 15.0559 18.5538 15.4472 18.6419 15.8222L19.8069 21.7157C20.0181 22.6148 19.006 23.3203 18.1799 22.8497L12.559 19.6479C12.2144 19.4516 11.7856 19.4516 11.441 19.6479L5.82013 22.8497C4.99404 23.3203 3.98187 22.6148 4.1931 21.7157L5.50456 15.8222C5.59267 15.4472 5.46015 15.0559 5.15909 14.8022L0.373734 10.4391C-0.348049 9.83081 0.0385653 8.68933 0.995201 8.60422L7.2626 7.72204C7.66162 7.68654 8.00855 7.44474 8.16705 7.09165L10.9944 1.63488Z"
      fill={color}
    />
  </svg>
);
